/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompareRequestDto } from '../models/CompareRequestDto';
import type { CompareResultDto } from '../models/CompareResultDto';
import type { PullRequestDto } from '../models/PullRequestDto';
import type { PullResultDto } from '../models/PullResultDto';
import type { SourceDatabasesResponseDto } from '../models/SourceDatabasesResponseDto';
import type { SourceSysOrgDto } from '../models/SourceSysOrgDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CrossDbSyncService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Returns the list of configured source database names.
     * @returns SourceDatabasesResponseDto OK
     * @throws ApiError
     */
    public getApiCrossDbSyncSources(): CancelablePromise<SourceDatabasesResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/CrossDbSync/sources',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Returns the list of SysOrgs available in the specified source database.
     * @param sourceName
     * @returns SourceSysOrgDto OK
     * @throws ApiError
     */
    public getApiCrossDbSyncGetSourceSysOrgs(
        sourceName: string,
    ): CancelablePromise<Array<SourceSysOrgDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/CrossDbSync/{sourceName}/GetSourceSysOrgs',
            path: {
                'sourceName': sourceName,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Compares a source SysOrg (in a remote database) against a target SysOrg (in the current database).
     * @param requestBody
     * @returns CompareResultDto OK
     * @throws ApiError
     */
    public postApiCrossDbSyncCompare(
        requestBody?: CompareRequestDto,
    ): CancelablePromise<CompareResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/CrossDbSync/compare',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Pulls selected items from a source SysOrg into the target SysOrg.
     * @param requestBody
     * @returns PullResultDto OK
     * @throws ApiError
     */
    public postApiCrossDbSyncPull(
        requestBody?: PullRequestDto,
    ): CancelablePromise<PullResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/CrossDbSync/pull',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
